import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import StatusBadge from '../common/StatusBadge';
import { LogoutIcon } from '../common/Icons';

export default function Topbar({ title, onMenuClick }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        {/* 모바일 전용 햄버거(사이드바 드로어 토글). 데스크톱에선 CSS 로 숨김 */}
        <button type="button" className="topbar-hamburger" onClick={onMenuClick} aria-label="메뉴 열기">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <div className="topbar-title">{title}</div>
      </div>
      <div className="topbar-user">
        <span className="topbar-user-name">{auth?.adminName}</span>
        <StatusBadge value={auth?.roleCode} />
        <button className="btn btn-ghost btn-sm" onClick={handleLogout}>
          <LogoutIcon /> 로그아웃
        </button>
      </div>
    </header>
  );
}
